import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=745b102d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=745b102d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b102d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745b102d')) {
      api.createRecord('745b102d', component.options)
    } else {
      api.reload('745b102d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=745b102d&scoped=true&", function () {
      api.rerender('745b102d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hFCXK7G64gei/JS/comp/PopupBox.vue"
export default component.exports